import React, { Component, Fragment } from 'react';
import { Button, Header, Icon, Loader, Segment, SegmentGroup } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../util/css';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { FACULTY_ADMIN, fetchActiveRole, fetchUserOrganizationalUnit } from '../util/roles';
import {
    checkFaculty,
    checkOrganizationalUnitsPrivilege,
    DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
    getTotalNumberOfPages
} from '../util/util';
import VehicleList from './VehiclesList';
import NewVehicle from './NewVehicle';
import PaginationSegment from '../util/PaginationSegment';


class Vehicles extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            activePage: 1,
            totalPages: 1,
            resultsPerPage: DEFAULT_NUMBER_OF_ITEMS_PER_PAGE,
            vehicles: [],
            openNewVehicle: false,
            loader: true
        };
        this.getUserData = this.getUserData.bind(this);
        this.fetchAllVehicles = this.fetchAllVehicles.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleResultsPerPageChange = this.handleResultsPerPageChange.bind(this);
        this.deleteVehicle = this.deleteVehicle.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    getUserData() {
        axios.all([fetchActiveRole(), fetchUserOrganizationalUnit()])
            .then(axios.spread((activeRoleRes, userOrganizationalUnitRes) => {
                const activeRole = activeRoleRes.data;
                const organizationalUnitId = userOrganizationalUnitRes.data;
                this.setState({ activeRole, organizationalUnitId });
                if (checkFaculty(activeRole)) {
                    this.fetchAllVehicles();
                } else {
                    this.fetchAllVehicles();
                }
            }))
            .catch(err => {
                this.setState({ error: true, loader: false });
                console.log('Failed to fetch data.');
            });
    }

    fetchAllVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        this.fetchVehicles(page, resultsPerPage).then((res) => {
            const vehicles = res.data.responseList;
            let totalPages = getTotalNumberOfPages(res.data.total, DEFAULT_NUMBER_OF_ITEMS_PER_PAGE);
            this.setState({ vehicles, totalPages, loader: false });
            this.updateVehicles(page, resultsPerPage, res);
        });
    }


    fetchVehicles(page = 0, resultsPerPage = DEFAULT_NUMBER_OF_ITEMS_PER_PAGE) {
        const pagination = {
            page,
            resultsPerPage,
        };

        return axios.post('/assets/vehicle/paginated/', { ...pagination });
    }

    getWritePrivilege() {
        const activeRole = localStorage.getItem('activeRole');
        if (activeRole === FACULTY_ADMIN || activeRole.substr(0, 18) === FACULTY_ADMIN) {
            return true;
        }
        return false;
    }

    handlePageChange(e, { activePage }) {
        if (activePage === this.state.activePage) {
            return;
        }

        if (this.state.showFiltersOnButton) {
            // this.getFilteredVehicles(activePage - 1, this.state.resultsPerPage);
        } else {
            this.fetchAllVehicles(activePage - 1, this.state.resultsPerPage);
        }
    }

    handleResultsPerPageChange(e, { value }) {
        if (this.state.showFiltersOnButton) {
            // this.getFilteredVehicles(0, value);
            return;
        }

        this.fetchAllVehicles(0, value);
    }

    getVehicles(page, resultsPerPage, sortingDTO = null) {
        const {
            activeRole, fieldName, fieldProperty, direction
        } = this.state;
        const pagination = {
            page,
            resultsPerPage,
            fieldName: sortingDTO ? sortingDTO.fieldName : fieldName,
            fieldProperty: sortingDTO ? sortingDTO.fieldProperty : fieldProperty,
            order: sortingDTO ? sortingDTO.direction === 'ascending' : direction ? direction === 'ascending' : null,
        };

        if (checkOrganizationalUnitsPrivilege(activeRole)) {
            axios.post('/assets/vehicle/all/', { ...pagination })
                .then(res => {
                    this.updateVehicles(page, resultsPerPage, res);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Greska!');
                });
        } else if (checkFaculty(activeRole)) {
            axios.post('/assets/vehicle/paginated/', { ...pagination })
                .then(res => {
                    this.updateVehicles(page, resultsPerPage, res);
                })
                .catch(err => {
                    toast('Došlo je do greške!');
                    console.log('Greska!');
                });
        }
    }

    updateVehicles(page, resultsPerPage, res) {
        let totalPages = getTotalNumberOfPages(res.data.total, resultsPerPage);

        this.setState(prevState => ({
            activePage: page + 1,
            resultsPerPage,
            totalPages
        }));
    }

    deleteVehicle(id) {
        axios.delete(`/assets/vehicle/delete/${id}`)
            .then(res => {
                toast('Brisanje vozila je uspješno izvršeno.');
                this.fetchAllVehicles();
            })
            .catch(err => {
                toast('Došlo je do greške! Brisanje nije uspješno izvršeno.');
            });
    }

    render() {
        const writePrivilege = this.getWritePrivilege();
        const { vehicles } = this.state;
        return (
            <div>
                <Header as="h1">Vozila</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Spisak vozila
                            { writePrivilege && <Header style={IconHeader} floated="right"> <Button
                                color="blue"
                                floated="right"
                                icon
                                labelPosition="right"
                                size="small"
                                style={FiltersOnStyle}
                                onClick={() => this.setState({ openNewVehicle: true })}
                            ><Icon className="add" />
                                Dodavanje vozila
                            </Button>
                            </Header>}

                        </Header>
                    </Segment>
                    <Segment>
                        {this.state.openNewVehicle && <NewVehicle
                            organizationalUnitId={this.state.organizationalUnitId}
                            activeRole={this.state.activeRole}
                            fetchAllVehicles={this.fetchAllVehicles}
                            closeForm={() => this.setState({ openNewVehicle: false })}
                        />}
                        { this.state.loader ?
                            <Loader active inline="centered" />
                            :

                            vehicles && vehicles.length ?
                            // eslint-disable-next-line react/jsx-no-undef
                                <Fragment>
                                    <VehicleList
                                        vehicles={vehicles}
                                        activateEditRequest={this.activateEditRequest}
                                        deleteVehicle={this.deleteVehicle}
                                    />
                                    <PaginationSegment
                                        activePage={this.state.activePage}
                                        totalPages={this.state.totalPages}
                                        onPageChange={this.handlePageChange}
                                    />
                                </Fragment>

                                : 'Nema podataka o vozilima.'
                        }

                    </Segment>

                </SegmentGroup>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default Vehicles;



// WEBPACK FOOTER //
// ./src/views/Assets/Vehicles/Vehicles.js